// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3GljE","inputWrap":"styles_inputWrap__riMUe","input":"styles_input__22dQu"};